package br.com.vvrefeicoes.portal.domain.model

/** Prioridade do comunicado/notificação; define onde ela aparece no app. */
enum class NotificationPriority {
    LOW,
    MEDIUM,
    HIGH,
}

/** Notificação do usuário, gerada a partir de um comunicado. */
data class AppNotification(
    val id: String,
    val title: String,
    val body: String,
    val priority: NotificationPriority,
    val imageUrl: String?,
    val publishedAt: String?,
    val read: Boolean,
    val dismissed: Boolean,
)

data class NotificationsFeed(
    val items: List<AppNotification>,
    val unreadCount: Int,
    val totalPages: Int = 1,
)

/** Forma de segmentação do público de um comunicado. */
enum class AnnouncementAudience {
    ROLE,
    UNIT,
    USER,
}

data class AnnouncementTarget(
    val type: AnnouncementAudience,
    val ref: String,
)

data class Announcement(
    val id: String,
    val title: String,
    val body: String,
    val priority: NotificationPriority,
    val imageUrl: String?,
    val active: Boolean,
    val publishedAt: String?,
    val createdAt: String?,
    val updatedAt: String? = null,
    val targets: List<AnnouncementTarget>,
)

data class AnnouncementDraft(
    val title: String,
    val body: String,
    val priority: NotificationPriority,
    val imageUrl: String?,
    val active: Boolean,
    val targets: List<AnnouncementTarget>,
)
